module.exports = require("core-js/modules/es.array.concat.js");